import PlayButton from "../../../components/common/playButton";
import { ImPlay2 } from "react-icons/im";
import { t, getLang } from "../../../lang";
import {useEffect, useState} from "react";
export default function GameDemo(){
    const [lang, setLangState] = useState(getLang());

    useEffect(() => {
        const handler = () => setLangState(getLang());
        window.addEventListener("langChanged", handler);
        return () => window.removeEventListener("langChanged", handler);
    }, []);

    return(
        <div className="liveGameDemo">
            <div className="newgame-title">
                <span className="page-title">{t("game.gems_bonanza")}</span>
                <span>{t("game.game_demo")}</span>
            </div>
            <div className="liveGameDemo-image">
                <img src="/img/live1.png" alt="gameDemo" />
            </div>
            <div className="btn_playForReal">
                <PlayButton title ={ <span className="playForReal">{t("common.play_for_real")} <ImPlay2 /></span> } action = { () => {} }/>
            </div>
        </div>
    )
}